@import ../../../styles/helpers

.modal_container
    max-width: 800px
    border-radius: 16px
    background-color: $neutrals2
    padding: 20px
    padding-bottom: 40px
    position: relative
    padding-top: 80px
    padding-bottom: 80px

.actioner
    background-color: $dark_contrast
    border-radius: 100%
    img
        width: $icon_size
        height: $icon_size
    +m
        img
            width: $icon_size_m
            height: $icon_size_m

.head
    position: relative
    display: flex
    align-items: center
    +button-2
    cursor: pointer
    transition: box-shadow .2s
    justify-content: center

    +m
        padding: 0
        border-radius: 10px
        box-shadow: none

.avatar
    display: flex
    flex-shrink: 0
    width: 65px
    height: 65px
    flex-direction: row
    justify-content: flex-end
    align-items: center
    gap: 15px
    color: white
    img
        width: 100%
        height: 100%
        border-radius: 50%
.button
    width: 100%
    height: 32px
    padding: 0 10px
    font-size: 14px